<div class="revocation-no-login__row" id="revocationNoLoginHeader">
  <div class="revocation-no-login__header col-12">
    <h3 class="revocation-no-login__intro"
        *appApplyIfNotEmpty="translationService.getTranslation('revocation_intro')"
        [innerHTML]="translationService.getTranslation('revocation_intro')"></h3>
  </div>
  <mat-card class="revocation-no-login__card mt-3">
    <mat-card-content class="revocation-no-login__content">
      <p class="revocation-no-login__description col-12 mb-3"
         [innerHTML]="translationService.getTranslation('revocation_unauthorized_description')"></p>

      <div class="revocation-no-login__errors col-12">
        <app-general-errors [errors]="errorsArr"></app-general-errors>
      </div>

      <div class="revocation-no-login__spinner" style="text-align: center;" *ngIf="isLoading">
        <app-loading-spinner></app-loading-spinner>
      </div>

      <form [formGroup]="identificationForm" class="revocation-no-login__form" (ngSubmit)="onSubmit()" *ngIf="!isLoading">
        <div class="row">
          <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
              <mat-label [innerHTML]="translationService.getTranslation('address_firstname')"></mat-label>
              <input matInput formControlName="firstName" autocomplete="given-name">
              <mat-error *ngIf="identificationForm.get('firstName').invalid && identificationForm.get('firstName').touched"
                         [innerHTML]="translationService.getTranslation('error_required')"></mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
              <mat-label [innerHTML]="translationService.getTranslation('address_lastname')"></mat-label>
              <input matInput formControlName="lastName" autocomplete="family-name">
              <mat-error *ngIf="identificationForm.get('lastName').invalid && identificationForm.get('lastName').touched"
                         [innerHTML]="translationService.getTranslation('error_required')"></mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
              <mat-label [innerHTML]="translationService.getTranslation('label_email')"></mat-label>
              <input matInput formControlName="email" type="email" autocomplete="email">
              <mat-error *ngIf="identificationForm.get('email').hasError('required') && identificationForm.get('email').touched"
                         [innerHTML]="translationService.getTranslation('error_required')"></mat-error>
              <mat-error *ngIf="identificationForm.get('email').hasError('email') && identificationForm.get('email').touched"
                         [innerHTML]="translationService.getTranslation('error_email_invalid')"></mat-error>
            </mat-form-field>
          </div>
          <div class="col-12 col-md-6">
            <mat-form-field class="w-100">
              <mat-label [innerHTML]="translationService.getTranslation('label_order_no')"></mat-label>
              <input matInput formControlName="orderNo">
              <mat-error *ngIf="identificationForm.get('orderNo').invalid && identificationForm.get('orderNo').touched"
                         [innerHTML]="translationService.getTranslation('error_required')"></mat-error>
            </mat-form-field>
          </div>
        </div>
        <mat-card-actions class="revocation-no-login__actions">
          <button ngSkipHydration mat-raised-button color="primary"
                  type="submit"
                  class="revocation-no-login__submit-btn"
                  [disabled]="identificationForm.invalid"
                  [innerHTML]="translationService.getTranslation('button_revocation_submit')">
          </button>
        </mat-card-actions>
      </form>
    </mat-card-content>
  </mat-card>
</div>
